import { useStoryblokState } from '@cinch-nx/data-storyblok'
import { Head, LandingPage } from '@cinch-nx/landing-ui-shared'
import { StoryblokRendererV2 as StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { ServicingPageProps } from './get-static-props'
import { useEffect } from 'react'

import styles from './servicing-page.module.css'
import { servicingStoryblokComponents } from './storyblok/data/storyblok-renderer-map'

export const ServicingPage = ({ story, preview }: ServicingPageProps) => {
  const { content } = useStoryblokState<LandingPage>({
    story,
    enableBridge: preview,
  })

  const SEO = content?.SEO?.[0] ?? {}

  useEffect(() => {
    const ctaLink = document.querySelector(
      "a[href='/car-care/servicing/book']",
    ) as HTMLElement
    if (!ctaLink) return

    const parentWrapper = ctaLink.closest(
      'div[class*="wrapper_wrapper"]',
    ) as HTMLElement
    if (!parentWrapper) return

    const originalOffsetTop = parentWrapper.offsetTop

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      if (scrollTop >= originalOffsetTop) {
        parentWrapper.style.setProperty('position', 'fixed', 'important')
        parentWrapper.style.setProperty('top', '0', 'important')
        parentWrapper.style.setProperty('left', '0', 'important')
        parentWrapper.style.setProperty('right', '0', 'important')
        parentWrapper.style.setProperty('width', '100%', 'important')
        parentWrapper.style.setProperty('max-height', '75px', 'important')
        parentWrapper.style.setProperty('max-width', '100%', 'important')
        parentWrapper.style.setProperty(
          'background-color',
          '#ffffff',
          'important',
        )
        parentWrapper.style.setProperty(
          'box-shadow',
          '0 4px 12px rgb(0 0 0 / 15%)',
          'important',
        )
        parentWrapper.style.setProperty('z-index', '1000', 'important')
        parentWrapper.style.setProperty('margin', '0', 'important')
        parentWrapper.style.setProperty('padding', '12px 16px', 'important')
      } else {
        parentWrapper.style.removeProperty('position')
        parentWrapper.style.removeProperty('top')
        parentWrapper.style.removeProperty('left')
        parentWrapper.style.removeProperty('right')
        parentWrapper.style.removeProperty('width')
        parentWrapper.style.removeProperty('max-height')
        parentWrapper.style.removeProperty('max-width')
        parentWrapper.style.removeProperty('background-color')
        parentWrapper.style.removeProperty('box-shadow')
        parentWrapper.style.removeProperty('z-index')
        parentWrapper.style.removeProperty('margin')
        parentWrapper.style.removeProperty('padding')
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <>
      <Head
        {...SEO}
        fallbackTitle="Servicing Page - cinch"
        fallbackDescription="We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
      />

      <article className={styles.pageWrapper}>
        <StoryblokRenderer
          block={content.body}
          components={servicingStoryblokComponents}
        />
      </article>
    </>
  )
}
